import { BlogPosts } from "@/components/Blog posts";

export function FollowUpEmailThankYouPage() {
  return (
    <div className="max-w-[1500px] mx-auto h-full min-h-screen flex px-4 xl:px-16 py-[10dvh] flex-col items-center">
      <div className="flex flex-col justify-center gap-[10dvh]">
        <div className="w-full h-full flex flex-col gap-16 xl:flex-row xl:justify-between items-center">
          <div className="flex flex-col gap-12 w-full xl:w-[50%]">
            <div className="relative h-16 w-16 rounded-full flex justify-center items-center">
              <div className="bg-[#17D384] h-full w-full animate-pulse-scale rounded-full absolute inset-0" />
              <img
                src="/checkout-success/success-check.svg"
                className={`bg-[#17D384] h-full w-full p-4 rounded-full absolute inset-0 z-10`}
                alt="Success icon"
              />
            </div>
            <h2 className="text-6xl font-semibold">
              You're on our radar! We'll follow up soon
            </h2>
            <p>
              We'll reach out in <strong>a few months</strong> with a fresh
              quote once you've built up enough miles. In the meantime, here's
              how to earn more, protect your miles from devaluation, and get the
              best cash value when you're ready to sell. <br />
              <br />
              P.S. If your balance grows faster than expected, you can request a
              new quote anytime.
            </p>
          </div>
          <img
            src="/checkout-success/banner.svg"
            className="h-full max-h-[85dvh]"
            alt="Thank you banner illustration"
          />
        </div>

        <BlogPosts />
      </div>
    </div>
  );
}
